module.exports = __webpack_public_path__ + "first-500-hologram.jpg?896ce860218c1491cc3e0d63e9def1c8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-500-hologram.jpg
// module id = 541
// module chunks = 0